import React from 'react';

const ExperienceForm = ({ data, onChange }) => {
  const addExperience = () => {
    onChange([...data, {
      jobTitle: '',
      company: '',
      location: '',
      startDate: '',
      endDate: '',
      responsibilities: ['']
    }]);
  };

  const removeExperience = (index) => {
    const newData = data.filter((_, i) => i !== index);
    onChange(newData);
  };

  const updateExperience = (index, field, value) => {
    const newData = [...data];
    newData[index][field] = value;
    onChange(newData);
  };

  const addResponsibility = (expIndex) => {
    const newData = [...data];
    if (!newData[expIndex].responsibilities) {
      newData[expIndex].responsibilities = [];
    }
    newData[expIndex].responsibilities.push('');
    onChange(newData);
  };

  const removeResponsibility = (expIndex, respIndex) => {
    const newData = [...data];
    newData[expIndex].responsibilities = newData[expIndex].responsibilities.filter((_, i) => i !== respIndex);
    onChange(newData);
  };

  const updateResponsibility = (expIndex, respIndex, value) => {
    const newData = [...data];
    newData[expIndex].responsibilities[respIndex] = value;
    onChange(newData);
  };

  return (
    <div className="form-section">
      <h2 className="section-title">Work Experience</h2>
      <p className="section-description">
        List your work experience in reverse chronological order (most recent first). 
        Include measurable achievements and use action verbs.
      </p>

      {data.map((exp, index) => (
        <div key={index} className="entry-card">
          <div className="entry-header">
            <span className="entry-number">Position {index + 1}</span>
            {data.length > 1 && (
              <button
                className="remove-button"
                onClick={() => removeExperience(index)}
              >
                Remove
              </button>
            )}
          </div>

          <div className="form-group">
            <label className="form-label required">Job Title</label>
            <input
              type="text"
              className="form-input"
              value={exp.jobTitle}
              onChange={(e) => updateExperience(index, 'jobTitle', e.target.value)}
              placeholder="Senior Software Engineer"
            />
          </div>

          <div className="form-group">
            <label className="form-label required">Company</label>
            <input
              type="text"
              className="form-input"
              value={exp.company}
              onChange={(e) => updateExperience(index, 'company', e.target.value)}
              placeholder="Tech Corp Inc."
            />
          </div>

          <div className="form-group">
            <label className="form-label">Location</label>
            <input
              type="text"
              className="form-input"
              value={exp.location}
              onChange={(e) => updateExperience(index, 'location', e.target.value)}
              placeholder="San Francisco, CA"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Start Date</label>
              <input
                type="text"
                className="form-input"
                value={exp.startDate}
                onChange={(e) => updateExperience(index, 'startDate', e.target.value)}
                placeholder="Jan 2020"
              />
            </div>

            <div className="form-group">
              <label className="form-label">End Date</label>
              <input
                type="text"
                className="form-input"
                value={exp.endDate}
                onChange={(e) => updateExperience(index, 'endDate', e.target.value)}
                placeholder="Present"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Responsibilities</label>
            <div style={{ marginTop: '0.5rem', maxWidth: '100%', overflow: 'hidden' }}>
              {(exp.responsibilities || ['']).map((resp, respIndex) => (
                <div key={respIndex} style={{ 
                  display: 'flex', 
                  gap: '0.5rem', 
                  marginBottom: '0.75rem',
                  alignItems: 'flex-start',
                  maxWidth: '100%',
                  width: '100%'
                }}>
                  <input
                    type="text"
                    className="form-input"
                    value={resp}
                    onChange={(e) => updateResponsibility(index, respIndex, e.target.value)}
                    placeholder={`Responsibility ${respIndex + 1}`}
                    style={{ flex: 1, minWidth: 0, maxWidth: '100%' }}
                  />
                  {(exp.responsibilities || []).length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeResponsibility(index, respIndex)}
                      style={{
                        backgroundColor: '#e74c3c',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        width: '32px',
                        minWidth: '32px',
                        height: '38px',
                        cursor: 'pointer',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                      }}
                      title="Remove responsibility"
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
              <button
                type="button"
                onClick={() => addResponsibility(index)}
                style={{
                  backgroundColor: '#3498db',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '0.5rem 1rem',
                  cursor: 'pointer',
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  marginTop: '0.25rem',
                  maxWidth: '100%'
                }}
              >
                + Add Responsibility
              </button>
            </div>
            <p className="form-hint" style={{ marginTop: '0.75rem' }}>
              💡 Each responsibility will become a bullet point. Start with action verbs and include metrics where possible.
            </p>
          </div>
        </div>
      ))}

      <button className="add-button" onClick={addExperience}>
        + Add Another Position
      </button>
    </div>
  );
};

export default ExperienceForm;
